import * as React from 'react';

import { Label, Icon } from './styles';

export enum RadioBoxTheme {
	DARK = 'DARK',
	LIGHT = 'LIGHT',
}

interface RadioBoxProps {
	name: string;
	label?: string | React.ReactNode;
	value: string;
	isChecked: boolean;
	isDisabled?: boolean;
	theme?: RadioBoxTheme;
	onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

const RadioBox = ({
	name,
	label,
	value,
	isChecked,
	isDisabled,
	theme = RadioBoxTheme.LIGHT,
	onChange,
}: RadioBoxProps) => (
	<Label
		isActive={isChecked}
		theme={theme}
	>
		<input
			type="radio"
			name={name}
			value={value}
			checked={isChecked}
			disabled={isDisabled}
			onChange={onChange}
		/>
		<Icon
			isActive={isChecked}
			theme={theme}
		/>
		{label}
	</Label>
);

export default RadioBox;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/RadioBox/index.tsx